export default __webpack_public_path__ + "static/media/denet_logo.9c39728a.png";